export const TAGNAMES_RESET_STATE = 'TAGNAMES_RESET_STATE';
export const TAGNAMES_CURRENT_ITEM = 'TAGNAMES_CURRENT_ITEM';

export const TAGNAMES_REQUEST_LOADING = 'TAGNAMES_REQUEST_LOADING';
export const TAGNAMES_REQUEST_SUCCESS = 'TAGNAMES_REQUEST_SUCCESS';
export const TAGNAMES_REQUEST_FAILED = 'TAGNAMES_REQUEST_FAILED';

export const TAGNAMES_CURRENT_ACTION = 'TAGNAMES_CURRENT_ACTION';
export const TAGNAMES_RESET_ACTION = 'TAGNAMES_RESET_ACTION';
